import { render, staticRenderFns } from "./CookiesManagement.vue?vue&type=template&id=2095abfc&"
import script from "./CookiesManagement.vue?vue&type=script&lang=js&"
export * from "./CookiesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports